module.exports = __webpack_public_path__ + "static/media/ap.6aa8bebc.png";